import { PageAccessRecipientRecord } from "models/view-models/page-access-recipient-record";
import ServiceHookFactory from "utilities/services/service-hook-factory";

export interface SharedPageRecipientResourcePathParams {
    pageGuid: string;
}
export interface SharedPageRecipientQueryParams {
    recipientGuid: string;
}

const endpoint: string = "shared/pages/:pageGuid/recipients";
const resourceType = PageAccessRecipientRecord;

const SharedPageRecipientsService = {
    useGet: ServiceHookFactory.useGet<
        PageAccessRecipientRecord,
        SharedPageRecipientResourcePathParams,
        SharedPageRecipientQueryParams
    >(resourceType, endpoint),
};

export default SharedPageRecipientsService;
